// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7374":"e3b75532","8596":"31d6cfe0","9561":"94a85530"}[chunkId] + ".chunk.css";
};